module.exports = __webpack_public_path__ + "static/media/peakbaccrat.111b03a2.png";